import { createTheme } from '@mui/material/styles';

const font = "'Roboto', 'Helvetica', 'Arial', sans-serif";

const myProps = {
  shape: { borderRadius: 24 },
};

const myComponents = {
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        borderRadius: 20,
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: 20,
      },
    },
  },
  MuiCard: {
    defaultProps: {
      elevation: 0,
    },
  },
  MuiCardContent: {
    styleOverrides: {
      root: {
        padding: 24,
      },
    },
  },
  typography: {
    fontFamily: font,
  },
};

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#D50000', //D50000 //1b73e8
    },
    background: {
      paper: '#fff',
      default: '#f4f6f9',
    },
    text: {
      primary: '#202124',
      secondary: '#3c4043',
    },
  },
  components: {
    ...myComponents,
  },
  ...myProps,
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#D50000' }, //D50000 //1b73e8
    background: {
      paper: '#202020',
      default: '#181818',
    },
    text: {
      primary: 'rgba(255 255 255/0.87)',
      secondary: 'rgba(255 255 255/0.6)',
    },
  },
  components: {
    ...myComponents,
  },
  ...myProps,
});

// Create a theme instance.
